if (window.storeSwitcherSettings && window.geoIpDetectionSettings) {
  const settings = window.geoIpDetectionSettings;

  let designMode = settings.designMode;

  let txtRegionTitle = settings.txtRegionTitle,
    txtRegionRedirectStore = settings.txtRegionRedirectStore,
    txtRegionStayStore = settings.txtRegionStayStore,
    txtregionMiscDesc = settings.txtregionMiscDesc,
    txtregionSelector = settings.txtregionSelector;

  const $regionLocator = jQuery('#region-locator');
  $regionTitle = jQuery('#region-locator-title'),
    $regionRedirect = jQuery('#region-locator-redirect'),
    $regionStay = jQuery('#region-locator-stay'),
    $regionClose = jQuery('#region-locator-close'),
    $regionMiscDesc = jQuery('#region-misc-desc'),
    $regionSelector = jQuery('#region-selector'),
    $regionElseWhere = jQuery('#region-locator-elsewhere'),
    $elseWhereToggle = jQuery('#region-locator-elsewhere-toggle');

  let thisStoresRequestPath = window.location.pathname;

  if (thisStoresRequestPath.length == 1) {
    thisStoresRequestPath = '';
  }

  let thisShopUrl = `${Shopify.routes.url}`;

  // Fallbacks for development stores.
  if (thisShopUrl.includes('kazam-development')) {
    // UK Dev
    thisShopUrl = 'https://ukstore.hermanmiller.com/'
    // HK Dev
  } else if (thisShopUrl.includes('kazam-apmea-test')) {
    thisShopUrl = 'https://www.hermanmiller.hk/'
  }

  const makeHttpRequest = (url) => {
    return new Promise(function (resolve, reject) {
      const xhr = typeof XMLHttpRequest != 'undefined' ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
      xhr.onreadystatechange = function () {
        let status;
        if (xhr.readyState == 4) {
          status = xhr.status;
          if (status == 200) {
            try {
              resolve(xhr.responseText);
            } catch (e) {
              reject(xhr.status)
            }
          }
        }
      };
      xhr.ontimeout = function () {
        reject('timeout');
      };
      xhr.withCredentials = true;
      xhr.open('get', url, true);
      xhr.send();
    });
  }

  async function getCountry() {
    const url = '/browsing_context_suggestions.json';
    const response = await makeHttpRequest(url);

    return JSON.parse(response);
  }

  const createCookie = (name, value, days) => {
    let expires = '';
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    }

    document.cookie = name + "=" + value + expires + "; path=/";
  }

  const readCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  const buttonStayOnClick = (e) => {
    $regionClose.trigger('click');
    event.preventDefault();
  }

  const buildElseWhereStore = () => {
    let html = '';

    const othersStore = window.storeSwitcherSettings.storesData.filter(el => el.link.indexOf(thisShopUrl) === -1);

    othersStore.forEach(el => {
      let elRequestPath = thisStoresRequestPath;

      if (el.is_shopify_store == false) {
        elRequestPath = '';
      }

      const link = el.link.replace(/\/$/, '') + elRequestPath + '?storeRedirect=' + el.name;
      html += `<li><a href="${link}"><span class="flag">${el.flag_svg}</span>${el.title}</a></li>`;
    });

    $regionElseWhere.html(html);
  }

  const bindEvents = (currentStore) => {

    $elseWhereToggle.click(function (event) {
      jQuery(event.currentTarget).parent().toggleClass('active');
    })

    $regionClose.click(function (event) {
      $regionLocator.fadeOut(300);
      createCookie('geoIPCookie', currentStore.code, 31);
      if (event) {
        event.preventDefault();
      }
    })

    jQuery(".js-close-reigon-locator").click(function (event) {
      $regionLocator.fadeOut(300);
      createCookie('geoIPCookie', currentStore.code, 31);
      if (event) {
        event.preventDefault();
      }
    })
  }

  const buildReigonLocator = (whichStoreData) => {
    const currentStore = window.storeSwitcherSettings.storesData.find(el => el.link.indexOf(thisShopUrl) !== -1);
    const whichStoreFullName = whichStoreData.title,
      whichStoreName = whichStoreData.name,
      whichStoreCode = whichStoreData.code,
      whichStoreLink = whichStoreData.link,
      whichStoreCurrency = whichStoreData.currency,
      whichStoreFlag = whichStoreData.flag_svg,
      whichStoreThisShopifyStore = whichStoreData.is_shopify_store;

    let thisStoresRequestPath = window.location.pathname;
    if (thisStoresRequestPath.length == 1) {
      thisStoresRequestPath = '';
    }

    txtRegionTitle = whichStoreData.region_title;
    txtRegionRedirectStore = whichStoreData.region_redirect;
    txtRegionStayStore = whichStoreData.region_stay;
    txtregionMiscDesc = whichStoreData.region_misc_desc;
    txtregionSelector = whichStoreData.region_selector;

    txtRegionTitle = txtRegionTitle.replace('{storeFullName}', whichStoreFullName);
    txtRegionRedirectStore = txtRegionRedirectStore.replace('{storeName}', whichStoreName).replace('{storeCurrency}', whichStoreCurrency);
    txtRegionStayStore = txtRegionStayStore.replace('{storeName}', currentStore.name).replace('{storeCurrency}', currentStore.currency);

    let whichRequestPath = thisStoresRequestPath;


    const linkRedirect = whichStoreThisShopifyStore == false ? whichStoreLink.replace(/\:$/, '') + '?storeRedirect=' + whichStoreName : whichStoreLink.replace(/\:$/, '') + whichRequestPath + '?storeRedirect=' + whichStoreName;

    const buttonRedirect = `<a href="${linkRedirect}" ><span class="flag">${whichStoreFlag}</span>${txtRegionRedirectStore}</a>`;
    const buttonStay = `<a href="#" class="js-close-reigon-locator"><span class="flag">${currentStore.flag_svg}</span>${txtRegionStayStore}</a>`;

    $regionTitle.html(txtRegionTitle);
    $regionRedirect.html(buttonRedirect);
    $regionStay.html(buttonStay);
    $regionMiscDesc.html(txtregionMiscDesc);
    $regionSelector.html(txtregionSelector);

    buildElseWhereStore();
    bindEvents(currentStore);
  }

  const openReigonLocator = () => {
    $regionLocator.fadeIn(300);
  }



  const processCountryCode = (whichCode, storeAction) => {
    let hasCountry = false;

    let whichStoreData = window.storeSwitcherSettings.storesData.filter(el => el.code == whichCode);

    if (whichStoreData.length) {
      hasCountry = true;
      whichStoreData = whichStoreData[0];
    }

    if (hasCountry) {

      if (whichStoreData.link.indexOf(thisShopUrl) === -1) {
        buildReigonLocator(whichStoreData);
        openReigonLocator();
      }
    }
  }

  const initGeoIP = () => {
    const hasRedirected = window.location.search.indexOf('storeRedirect');
    if (hasRedirected !== -1) {
      let countryName = window.location.search.replace('?storeRedirect=', '');
      createCookie('geoIPCookie', countryName, 31);
    } else {
      const geoIPCheck = readCookie('geoIPCookie');

      if (!geoIPCheck) {
        const countryData = getCountry();

        countryData.then(data => {
          processCountryCode(data.detected_values.country.handle, false);
        });
      }
    }
  }

  initGeoIP();
}
